namespace TabAurous.OMS {
    export interface GiftVoucherMasterForm {
        GvType: Serenity.LookupEditor;
        Code: Serenity.StringEditor;
        Value: Serenity.DecimalEditor;
        MinInvoiceValue: Serenity.DecimalEditor;
        ProdApp: Serenity.LookupEditor;
        Validity: Serenity.IntegerEditor;
        PartialRedeem: Serenity.BooleanEditor;
        Active: Serenity.BooleanEditor;
    }

    export class GiftVoucherMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.GiftVoucherMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GiftVoucherMasterForm.init)  {
                GiftVoucherMasterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(GiftVoucherMasterForm, [
                    'GvType', w0,
                    'Code', w1,
                    'Value', w2,
                    'MinInvoiceValue', w2,
                    'ProdApp', w0,
                    'Validity', w3,
                    'PartialRedeem', w4,
                    'Active', w4
                ]);
            }
        }
    }
}
